import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Crown, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
import { trackPixel } from '../../lib/metaPixel';
import { SectionTitle } from '../ui/SectionTitle';
const BASIC_CHECKOUT_URL = 'https://academiaholisticaargentina.com/cart/49691608187130:1';
const PREMIUM_CHECKOUT_URL = 'https://academiaholisticaargentina.com/cart/49691613528314:1';
const basicIncludes = ['12 Tomos Profesionales', 'Bono 1: Diccionario Profesional de las 78 Cartas', 'Bono 2: 50 Tiradas Profesionales', 'Bono 3: Cuaderno de Prácticas del Tarotista', 'Certificado digital', 'Acceso inmediato y de por vida'];
const premiumIncludes = [...basicIncludes, 'Bono Premium 1: Manual Profesional de Interpretación del Tarot', 'Bono Premium 2: Tarot Evolutivo y Arquetipos Profundos'];
function handleCheckout(plan: 'Básico' | 'Premium', value: number) {
  trackPixel('InitiateCheckout', {
    content_name: `MegaPack Tarot Profesional - ${plan}`,
    currency: 'ARS',
    value
  });
}
export function Pricing() {
  return <section id="pricing" className="relative z-10 scroll-mt-4 bg-mystic-900/80 py-10 md:py-20" data-id="element-196">
      <div className="container mx-auto px-4" data-id="element-197">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="mb-5 flex justify-center text-center" data-id="element-198">
          <SectionTitle data-id="element-199">Elegí tu formación</SectionTitle>
        </motion.div>

        <p className="mx-auto mb-10 max-w-2xl text-center text-sm leading-relaxed text-white/65 md:text-base" data-id="element-200">
          Empezá hoy con el formato que mejor se adapte a tu momento. La oferta
          Premium reúne la experiencia completa de MegaPack Tarot Profesional.
        </p>

        <div className="mx-auto grid max-w-5xl items-stretch gap-6 md:grid-cols-2 md:gap-5 lg:gap-7" data-id="element-201">
          <motion.article id="premium-offer" initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} className="relative order-1 flex scroll-mt-6 flex-col rounded-sm border border-gold/70 bg-mystic-800 p-4 pt-8 shadow-[0_0_36px_rgba(109,74,156,0.42)] sm:p-6 sm:pt-10 md:p-7 md:pt-11" aria-labelledby="premium-plan-title" data-id="element-202">
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-violet-dark via-violet-light to-violet-dark" data-id="element-203" />
            <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-204" />
            <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center gap-2 whitespace-nowrap rounded-sm border border-gold-light/60 bg-gradient-to-r from-violet-dark via-violet-accent to-violet-dark px-4 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white shadow-[0_0_18px_rgba(109,74,156,0.6)] sm:px-5 sm:text-xs" data-id="element-205">
              <Crown size={14} className="text-gold-light" data-id="element-206" />
              Más elegida
            </div>

            <div className="mb-4 flex flex-col gap-3 border-b border-gold/20 pb-4 sm:flex-row sm:items-start sm:justify-between" data-id="element-207">
              <div data-id="element-208">
                <div className="mb-1.5 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-gold sm:text-xs" data-id="element-209">
                  <Sparkles size={14} data-id="element-210" />
                  Experiencia completa
                </div>
                <h3 id="premium-plan-title" className="font-serif text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-211">
                  Formación Profesional Premium
                </h3>
                <p className="mt-1 text-xs text-white/65 sm:text-sm" data-id="element-212">
                  Todo lo de Formación Profesional, más 2 bonos Premium
                  exclusivos.
                </p>
              </div>
              <div className="shrink-0 text-left sm:text-right" data-id="element-213">
                <div className="text-[11px] font-medium uppercase tracking-wider text-white/50 sm:text-xs" data-id="element-214">
                  Pago único
                </div>
                <div className="mt-0.5 font-serif text-2xl font-bold text-gold-light sm:text-3xl" data-id="element-215">
                  ARS $29.990
                </div>
              </div>
            </div>

            <div className="mb-3 text-xs font-bold uppercase tracking-wider text-gold/80" data-id="element-216">
              Incluye
            </div>
            <ul className="mb-5 space-y-2" data-id="element-217">
              {premiumIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-218">
                  <CheckCircle2 size={16} className="mt-0.5 flex-shrink-0 text-gold" data-id="element-219" />
                  <span className="text-xs leading-snug text-white/90 sm:text-sm" data-id="element-220">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto flex flex-col items-center" data-id="element-221">
              <Button href={PREMIUM_CHECKOUT_URL} variant="violet" size="lg" onClick={() => handleCheckout('Premium', 29990)} className="py-3.5 text-sm shadow-[0_0_30px_rgba(109,74,156,0.65)] sm:text-base md:min-w-[240px] md:py-4" data-id="element-222">
                ACCEDER A PREMIUM
              </Button>
              <p className="mt-2 text-center text-xs text-white/50" data-id="element-223">
                Acceso digital inmediato · pago único
              </p>
            </div>
          </motion.article>

          <motion.article initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.06
        }} className="relative order-2 flex flex-col rounded-sm border border-gold/30 bg-mystic-800/70 p-4 sm:p-6 md:p-7" aria-labelledby="basic-plan-title" data-id="element-224">
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-transparent via-gold/70 to-transparent" data-id="element-225" />

            <div className="mb-4 flex flex-col gap-3 border-b border-gold/15 pb-4 sm:flex-row sm:items-start sm:justify-between" data-id="element-226">
              <div data-id="element-227">
                <div className="mb-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-white/50 sm:text-xs" data-id="element-228">
                  Formación completa
                </div>
                <h3 id="basic-plan-title" className="font-serif text-2xl font-bold leading-tight text-gold sm:text-3xl" data-id="element-229">
                  Formación Profesional
                </h3>
                <p className="mt-1 text-xs text-white/65 sm:text-sm" data-id="element-230">
                  12 tomos, 3 bonos y certificado digital.
                </p>
              </div>
              <div className="shrink-0 text-left sm:text-right" data-id="element-231">
                <div className="text-[11px] font-medium uppercase tracking-wider text-white/50 sm:text-xs" data-id="element-232">
                  Pago único
                </div>
                <div className="mt-0.5 font-serif text-2xl font-bold text-white sm:text-3xl" data-id="element-233">
                  ARS $19.990
                </div>
              </div>
            </div>

            <div className="mb-3 text-xs font-bold uppercase tracking-wider text-gold/80" data-id="element-234">
              Incluye
            </div>
            <ul className="mb-5 space-y-2" data-id="element-235">
              {basicIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-236">
                  <CheckCircle2 size={16} className="mt-0.5 flex-shrink-0 text-gold/80" data-id="element-237" />
                  <span className="text-xs leading-snug text-white/80 sm:text-sm" data-id="element-238">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto flex flex-col items-center border-t border-gold/15 pt-4" data-id="element-239">
              <Button href={BASIC_CHECKOUT_URL} variant="secondary" size="lg" onClick={() => handleCheckout('Básico', 19990)} className="py-3.5 text-sm sm:text-base md:min-w-[240px] md:py-4" data-id="element-240">
                ACCEDER A FORMACIÓN PROFESIONAL
              </Button>
              <p className="mt-2 text-center text-xs text-white/50" data-id="element-241">
                Acceso digital inmediato · pago único
              </p>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}